import { defineStore } from 'pinia'
import { ref } from 'vue'
import {
  EMPTY_BANLIST_LEVEL_REWARD,
  type BanlistLevelReward,
} from '@shared/index'

/**
 * New-duelist banlist picks. The server is the source of truth;
 * this store only mirrors the snapshot and whether the picker is open.
 */
export const useBanlistRewardStore = defineStore('banlistReward', () => {
  const anchorLevel = ref<number | null>(EMPTY_BANLIST_LEVEL_REWARD.anchorLevel)
  const unlocked = ref(0)
  const claimed = ref(0)
  const available = ref(0)
  const chosen = ref<string[]>([])
  const dialogOpen = ref(false)
  const snoozed = ref(false)

  function apply(next: BanlistLevelReward, reopen = false): void {
    const grew = next.available > available.value
    anchorLevel.value = next.anchorLevel
    unlocked.value = next.unlocked
    claimed.value = next.claimed
    available.value = next.available
    chosen.value = [...next.chosen]
    if (reopen || grew) snoozed.value = false
  }

  function openDialog(): void {
    if (available.value < 1) return
    dialogOpen.value = true
  }

  function closeDialog(): void {
    dialogOpen.value = false
  }

  function snooze(): void {
    snoozed.value = true
    dialogOpen.value = false
  }

  function clear(): void {
    apply({ ...EMPTY_BANLIST_LEVEL_REWARD, chosen: [] })
    dialogOpen.value = false
    snoozed.value = false
  }

  return {
    anchorLevel,
    unlocked,
    claimed,
    available,
    chosen,
    dialogOpen,
    snoozed,
    apply,
    openDialog,
    closeDialog,
    snooze,
    clear,
  }
})
